import Platform from "../../../../libs/utility/Platform";

export default {
    iconHW25: {
        width:'25px', 
        height: '25px'
    },
    switchLabelCustomStyle: {
        width: "28px",
        height: "14px",
    },
    switchButtonCustomStyle: {
        top: "1px",
        width: "10px",
        height: "10px",
    },
    navbarLogoStyles: {
        width: "166px",
        height: "45px",
    },
    allMenuIconDivStyles: {
        cursor: "pointer",
        marginRight: Platform.isMobileView() ? "0px" : "40px",
        marginLeft: "10px",
    }
}